<template>
  <div class="recommend-wrap">
    <div class="title">
      {{ !token? "逛一逛" : "猜你喜欢" }}
    </div>
    <div class="content">
      <div
        class="item-wrap"
        v-for="(item, index) in list"
        :key="index"
        @click="handleIsLogin('parts-detail', item)"
      >
        <div class="item-img-wrap">
          <div>
            <el-image
            v-if="item.AutoPartsPic1"
              style="width: 100%; height: 250px"
              :src="item.AutoPartsPic1"
              fit="cover"
            ></el-image>
            <img
              style="height:  250px; width: 100%; object-fit: cover"
              v-else src="../../../assets/Nofigure.png" alt="">
            <div
              class="bagPicBox"
              v-if="item.ActivePrice != item.Price && item.ActivePrice != 0"
            >
              <el-image
                :src="activityByCenter"
                style="width: 100%; height: 250px"
              />
            </div>
          </div>
        </div>
        <div class="item-text-wrap">
          <div class="name-vin-wrap">
            <span class="name-wrap">{{ item.AutoPartsName }}</span>
            <!-- <span class="vin-wrap">{{ item.VIN }}</span> -->
          </div>
          <div class="vehicle-wrap">
            <div class="single-ellipse">
              {{ item.VehicleName }}
            </div>
          </div>
          <div class="flex align-center justify-between">
            <div
              class="price-wrap-activity"
              v-if="item.ActivePrice != item.Price && item.ActivePrice != 0"
            >
              <span class="originalPrice">￥{{ item.ActivePrice }} </span>
              <span class="activityPrice">￥{{ item.Price }}</span>
            </div>

            <div class="price-wrap" v-else>{{ item.Price }}</div>
            <!-- <div class="price-wrap"></div> -->
            <div v-if="token">
              <div class="cart-wrap" @click.stop="handelSaveMyCart(item)">
                <img
                  style="width: 60%; height: 60%"
                  src="@/assets/shopCart.png"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { QueryItemList, SaveMyCart } from "@/api/merchant/dashboard";
import { activityByCenter } from "@/utils/activityImg.js";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      activityByCenter: activityByCenter,
      // list: [],
    };
  },
  inject: ["getRecommendList"],
  computed: {
    list() {
      return this.getRecommendList();
    },
    ...mapGetters(["token"]),
  },
  // created() {
  //   QueryItemList().then((res) => {
  //     this.list = res.List;
  //   });
  // },
  mounted() {
    // console.log(this.list)
  },
  methods: {
    handleLogin() {
      this.$emit("login", true);
    },
    handleIsLogin(path, cur) {
      if (!this.token) {
        this.handleLogin();
        // return true;
      } else {
        if (path.match(/^parts-detail$/)) {
          const { MctCode, BarCode, WhId, WhbId } = cur;
          var list = true;
          // this.$router.push({
          // 	path: "/parts-detail",
          // 	query: {MctCode, BarCode, WhId, WhbId, list}
          // })
          this.$router.push({
            path: `/parts-detail/?MctCode=${MctCode}&BarCode=${BarCode}&WhId=${WhId}&WhbId=${WhbId}&list=${true}`,
            // 传递的参数集合
          });
          return;
        }
        this.$router.push(path);
      }
    },
    handelSaveMyCart(item) {
      // SaveMyCart({ Data: item }).then((res) => {
      //   this.$message({
      //     type: "success",
      //     message: "添加成功",
      //   });
      // });
      this.$store.dispatch("merchant/addToCart", { Data: item }).then((res) => {
        this.$message({
          type: "success",
          message: "添加成功",
        });
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.cart-wrap {
  // position: absolute;
  cursor: pointer;
  position: relative;
  bottom: -5px;
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(254, 118, 72, 1);
  border-radius: 50%;
}
.recommend-wrap {
  margin-top: 40px;
  margin-bottom: 55px;
  .title {
    font-size: 26px;
    font-weight: 400;
    color: rgba(29, 32, 137, 1);
    text-align: center;
    margin-bottom: 20px;
  }
  .content {
    display: grid;
    // grid-template-columns: repeat(5, 20%);
    // grid-gap: 10px;
    grid-template-columns: repeat(5, 19.5%);
    /* grid-gap: 10px; */
    justify-content: space-between;
    grid-row-gap: 10px;
  }
  .item-wrap {
    position: relative;
    cursor: pointer;
    padding: 12px 12px 10px 12px;
    border-radius: 10px;
    background: rgba(255, 255, 255, 1);
    .item-img-wrap {
      position: relative;
      .bagPicBox {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 100%;
        // height: 250px;
        z-index: 12;
        // img {
        // 	width: 1005;
        // 	height: 250px;
        // }
      }
    }

    .item-text-wrap {
      .name-vin-wrap {
        color: rgba(56, 56, 56, 1);
        .name-wrap {
          font-size: 16px;
          font-weight: 600;
        }
        .vin-wrap {
          font-size: 12px;
          font-weight: 500;
        }
      }
      .vehicle-wrap {
        font-size: 12px;
        font-weight: 400;

        color: rgba(56, 56, 56, 1);
      }
      .price-wrap-activity {
        margin-top: 8px;
        position: relative;
        .originalPrice {
          font-size: 24px;
          font-weight: 700;
          color: rgba(254, 118, 72, 1);
        }
        .activityPrice {
          text-decoration-line: line-through;
          font-size: 12px;
          color: gray;
        }
      }
      .price-wrap {
        text-align: center;
        margin-top: 8px;
        position: relative;
        font-size: 24px;
        font-weight: 700;
        color: rgba(254, 118, 72, 1);
        &::before {
          content: "￥";
        }
      }
    }
  }
}
</style>
